export default [
    'login',
    'forgot-password',
    'register',
];
